var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcHelp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "question") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "help-and-support---Done",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Settings-main-page_-346",
    transform: "translate(-281, -463)",
    fill: "#DBE5FF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(260.9765, 356)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(1.0235, 100)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "question",
    transform: "translate(19, 7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,0 C5.81491016,0 0,5.81425 0,13 C0,20.1849883 5.81425,26 13,26 C20.1850898,26 26,20.18575 26,13 C26,5.81491016 20.18575,0 13,0 Z M12.615332,19.0845586 C11.8795117,19.0845586 11.3148242,18.4685312 11.3148242,17.7668867 C11.3148242,17.0481797 11.896625,16.4493164 12.615332,16.4493164 C13.3340898,16.4493164 13.9329023,17.0482305 13.9329023,17.7669375 C13.9329023,18.4684805 13.3511016,19.0845586 12.615332,19.0845586 Z M14.566043,12.428 C13.6249141,13.1638203 13.60775,13.677168 13.60775,14.566957 C13.60775,14.8921602 13.4366172,15.2686016 12.598168,15.2686016 C11.8965234,15.2686016 11.6570391,15.0119023 11.6570391,14.1221133 C11.6570391,12.6504727 12.307293,11.9488789 12.8035273,11.5210977 C13.3682148,11.0419258 14.3265078,10.5115156 14.3265078,9.5875 C14.3265078,8.80028906 13.6420273,8.42384766 12.7864141,8.42384766 C11.0410117,8.42384766 11.4175039,9.74151953 10.4933867,9.74151953 C10.0313789,9.74151953 9.46669141,9.43342969 9.46669141,8.76611328 C9.46669141,7.84209766 10.5276133,6.47308594 12.8377539,6.47308594 C15.0280508,6.47308594 16.4825781,7.68807812 16.4825781,9.29657422 C16.4825781,10.9050703 15.0280508,12.0686719 14.566043,12.428 Z",
    id: "Shape"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHelp);
export default __webpack_public_path__ + "static/media/ic_help.c524e448d2ae6bde882f06ba245c1110.svg";
export { ForwardRef as ReactComponent };